import {
    DeviceMobile,
    Desktop,
    ShieldCheck,
    Lightning,
    ArrowClockwise,
    Users
} from "@/app/components/Icons/Phosphoricons"; // ✅ Updated import

const features = [
    {
        name: 'Mobile Applications',
        description:
            'Custom iOS and Android apps with native performance, offline functionality, and seamless integration with device features.',
        icon: DeviceMobile,
    },
    {
        name: 'Desktop Solutions',
        description:
            'High-performance applications for Windows, macOS, and Linux that leverage the full capabilities of desktop environments.',
        icon: Desktop,
    },
    {
        name: 'Enhanced Security',
        description:
            'Enterprise-grade security with end-to-end encryption, biometric authentication, and compliance with industry standards.',
        icon: ShieldCheck,
    },
    {
        name: 'Performance Optimization',
        description:
            'Apps engineered for speed, efficiency, and minimal resource usage, ensuring smooth operation even on older devices.',
        icon: Lightning,
    },
    {
        name: 'Seamless Synchronization',
        description:
            'Real-time data synchronization across all platforms and devices, with robust offline capabilities and automatic conflict resolution.',
        icon: ArrowClockwise,
    },
    {
        name: 'Platform Strategy Consulting',
        description:
            'Expert guidance on cross-platform strategy, technology selection, and roadmap planning tailored to your business goals.',
        icon: Users,
    },
];

export default function HighlightsApps() {
    return (
        <div className="bg-white py-24 sm:py-32">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <div className="mx-auto max-w-2xl lg:text-center">
                    <h2 className="text-base/7 font-semibold text-blue-600">Cross Platform Excellence</h2>
                    <p className="mt-2 text-4xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-5xl lg:text-balance">
                        One Codebase, Every Platform
                    </p>
                    <p className="mt-6 text-lg/8 text-gray-600">
                        Maximize your development investment with applications that work seamlessly across mobile and desktop platforms,
                        delivering consistent experiences while reducing development time and maintenance costs.
                    </p>
                </div>
                <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-4xl">
                    <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-10 lg:max-w-none lg:grid-cols-2 lg:gap-y-16">
                        {features.map((feature) => (
                            <div key={feature.name} className="relative pl-16">
                                <dt className="text-base/7 font-semibold text-gray-900">
                                    <div className="absolute top-0 left-0 flex size-10 items-center justify-center rounded-lg bg-blue-600">
                                        <feature.icon aria-hidden="true" className="size-6 text-white" />
                                    </div>
                                    {feature.name}
                                </dt>
                                <dd className="mt-2 text-base/7 text-gray-600">{feature.description}</dd>
                            </div>
                        ))}
                    </dl>
                </div>
            </div>
        </div>
    )
}